import { useEffect, useState } from 'react';
import useCompetitionGenderTypeData from '../../../state/competitionGender/UseCompetitionGenderTypeData';

const useCompetitionGenderMultiSelect = () => {
  const { competitionGenderState, getCompetitionGenderTypes } = useCompetitionGenderTypeData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (competitionGenderState.isArrayLoading === false && competitionGenderState.isArrayLoaded === false) {
      getCompetitionGenderTypes();
    } else if (competitionGenderState.isArrayLoading === false && competitionGenderState.isArrayLoaded === true) {
      const competitionCategoryOptions = [];
      // eslint-disable-next-line no-debugger
      for (const competitionCategory of competitionGenderState.arrayData) {
        if (competitionCategory.competitionGenderTypeId > 0) {
          competitionCategoryOptions.push({ id: competitionCategory.competitionGenderTypeId, name: competitionCategory.typeName });
        }
      }

      setOptions(competitionCategoryOptions);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [competitionGenderState]);

  return {
    competitionGenderState,
    options
  };
};

export default useCompetitionGenderMultiSelect;